// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5754":"b66529f3","8759":"2299be90"}[chunkId] + ".chunk.css";
};